import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
